module.exports = __webpack_public_path__ + "media/team/background-02cd110c.png";